export enum Mode {
  Opened = 'opened',
  Closed = 'closed',
  Compact = 'compact',
  Expanded = 'expanded',
}
